// Brand constants for Mälair Installation AB
export const LOGO_DARK_BG = "https://customer-assets.emergentagent.com/job_bc07a5b0-4401-454c-9821-20d81dadd6da/artifacts/o2wvv1qn_AE66633E-D0C0-4E94-A20A-58BC375C1C43_1_105_c.jpeg";
export const LOGO_LIGHT_BG = "https://customer-assets.emergentagent.com/job_bc07a5b0-4401-454c-9821-20d81dadd6da/artifacts/21c8lw1c_fa793a21-0229-4214-a16b-e1c0df8a86d3.png";
export const BG_IMAGE = "https://images.unsplash.com/photo-1730651932588-85472ba690b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwdmVudGlsYXRpb24lMjBhcmNoaXRlY3R1cmUlMjBkYXJrfGVufDB8fHx8MTc4Mjc2Nzg1Nnww&ixlib=rb-4.1.0&q=85";
export const BRAND_GREEN = "#6dbf4a";

// Project color palette — 12 distinct hues that look good on dark bg
const PROJECT_COLORS = [
  "#6dbf4a", "#3b82f6", "#f59e0b", "#ef4444", "#8b5cf6", 
  "#06b6d4", "#ec4899", "#14b8a6", "#f97316", "#6366f1",
  "#84cc16", "#e879f9",
];

export function getProjectColor(projectId) {
  if (!projectId) return PROJECT_COLORS[0];
  let hash = 0;
  for (let i = 0; i < projectId.length; i++) {
    hash = projectId.charCodeAt(i) + ((hash << 5) - hash);
  }
  return PROJECT_COLORS[Math.abs(hash) % PROJECT_COLORS.length];
}
